import { LktNotificationPreferenceRow } from "@frontends-v3/design-system";

import { NotificationPreferenceGroupDto } from "../../../models/notifications/notification-preferences.interface";

/**
 * DTO do backend → linha visual do design-system, para a vista de preferências.
 *
 * É AQUI que a polaridade vira, e só aqui: o contrato registra o DESLIGAMENTO (`disabledChannels`,
 * lista vazia = recebe pelos dois), porque é o desligamento que o servidor grava; a tela mostra a
 * chavinha, que fala de LIGADO. O caminho de volta — a intenção de toque virando `disabled` do
 * PATCH — inverte uma vez só também, no `onPreferenceToggle` do container.
 *
 * Ausência é receber: canal fora da lista nasce ligado. Isso vale inclusive para um canal que o
 * front não conhecesse — nada aqui trava, esconde ou desabilita coluna por assunto, porque a API
 * não diz em quais canais um assunto é elegível e inventar essa regra no front seria fabricar
 * domínio (ver ARCHITECTURE.md, "Catálogo de notificações").
 *
 * `description` vem OMITIDO do payload quando é nula (toda linha de alerta crítico), então o
 * `?? null` é a normalização da fronteira, não defesa contra dado ruim.
 *
 * Precedente estrutural: `build-notification-item.util.ts`, ao lado.
 */
export function buildNotificationPreferenceRow(
  dto: NotificationPreferenceGroupDto
): LktNotificationPreferenceRow {
  return {
    toggleKey: dto.toggleKey,
    label: dto.label,
    description: dto.description ?? null,
    panelEnabled: !dto.disabledChannels.includes("panel"),
    emailEnabled: !dto.disabledChannels.includes("email")
  };
}
